export { default } from './QuestionCircleHollow'
